import type { CustomerTagColour } from '@tailoring-crm/shared';

/**
 * What each tag colour looks like: a solid dot or swatch, and a tinted chip whose text stays
 * legible in light and in dark mode — the same `/15` tint the stage badges use.
 *
 * Whole class strings, never assembled from the key, so Tailwind's scanner sees every one.
 */
export const TAG_COLOUR_CLASSES: Readonly<
  Record<CustomerTagColour, { dot: string; chip: string }>
> = Object.freeze({
  red: { dot: 'bg-red-400', chip: 'bg-red-500/15 text-red-700 dark:text-red-300' },
  orange: { dot: 'bg-orange-400', chip: 'bg-orange-500/15 text-orange-700 dark:text-orange-300' },
  amber: { dot: 'bg-amber-400', chip: 'bg-amber-500/15 text-amber-800 dark:text-amber-300' },
  yellow: { dot: 'bg-yellow-300', chip: 'bg-yellow-400/20 text-yellow-800 dark:text-yellow-200' },
  green: {
    dot: 'bg-emerald-400',
    chip: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  },
  teal: { dot: 'bg-teal-300', chip: 'bg-teal-500/15 text-teal-700 dark:text-teal-300' },
  blue: { dot: 'bg-sky-400', chip: 'bg-sky-500/15 text-sky-700 dark:text-sky-300' },
  violet: { dot: 'bg-violet-400', chip: 'bg-violet-500/15 text-violet-700 dark:text-violet-300' },
  pink: { dot: 'bg-pink-400', chip: 'bg-pink-500/15 text-pink-700 dark:text-pink-300' },
  grey: { dot: 'bg-slate-400', chip: 'bg-slate-500/15 text-slate-700 dark:text-slate-300' },
});
